const userActionTypes = {
  LOG_IN: "LOG_IN",
  LOG_OUT: "LOG_OUT",
  OPENNEWCHATMODAL: "OPENNEWCHATMODAL",
  CLOSENEWCHATMODAL: "CLOSENEWCHATMODAL",
};

export default userActionTypes;
